export const WXCC_ADDON_LABELS = {
  title: "Webex Contact Center Add-Ons",
  supported: "WxCC Add-Ons",
  unsupported: "Non-WxCC Add-Ons",
  all: "All Add-Ons",
  allButton: "All",
  closeDrawer: "Close add-ons drawer",
  viewAll: "View all",
  viewAllAria: "View all add-ons",
  filterPrefix: "Filter",
  clearFilter: "Clear add-ons filter",
  noMatches: "No add-ons match this filter.",
  noItems: "No add-ons available.",
  item: "item",
  items: "items",
  of: "of",
  total: "total",
} as const;

export const formatAddOnItemCount = (count: number) =>
  count + " " + (count === 1 ? WXCC_ADDON_LABELS.item : WXCC_ADDON_LABELS.items);

export const formatFilteredAddOnItemCount = (count: number, total: number) =>
  count + " " + WXCC_ADDON_LABELS.of + " " + formatAddOnItemCount(total);

export const formatAddOnCurrency = (value: number) =>
  "$" + value.toLocaleString("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
